import { render, staticRenderFns } from "./EditableString.vue?vue&type=template&id=4abd4890&"
import script from "./EditableString.vue?vue&type=script&lang=js&"
export * from "./EditableString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4abd4890')) {
      api.createRecord('4abd4890', component.options)
    } else {
      api.reload('4abd4890', component.options)
    }
    module.hot.accept("./EditableString.vue?vue&type=template&id=4abd4890&", function () {
      api.rerender('4abd4890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/EditableString.vue"
export default component.exports